import React, { useCallback } from 'react'
import styled from 'styled-components'

import Flex from 'components/reusable/flex'
import Indent from 'components/reusable/indent'
import Button from 'components/reusable/button'
import { BodyMain, H4, H6 } from 'components/views/help/help_faq_v2/components/styled'
import Settings from 'helpers/settings'
import Image from 'components/reusable/image'
import SvgArrowRightSolid from 'components/reusable/svg/svg_arrow_right_solid'
import Link from 'components/reusable/link'
import { colors } from 'helpers/colors'
import ModalCloseButton from 'components/modals/v2/modal_close_button'
import ModalStandardWrapper from 'components/modals/v2/modal_standard_wrapper'

const CallUsModal = ({ modalProps = {}, onClose }) => {
  const handleClose = useCallback(() => {
    if (typeof modalProps.callback === 'function') modalProps.callback()
    onClose()
  }, [modalProps.callback, onClose])

  const { andrea, paola } = Settings.support

  const items = [
    { label: andrea.firstName, desc: andrea.phoneLabel, imgSrc: andrea.imageSM, href: `tel:${andrea.phoneNumber}` },
    { label: paola.firstName, desc: paola.phoneLabel, imgSrc: paola.imageSM, href: `tel:${paola.phoneNumber}` },
  ]

  return (
    <ModalStandardWrapper>
      <ModalCloseButton onClose={handleClose} />
      <H4>Call Us</H4>
      <Indent bottom={32} />

      <Flex gap={12} dir="column" ai="flex-start">
        {items.map((item) => {
          return (
            <AgentWrapper key={item.label}>
              <Image src={item.imgSrc} width={48} br="100%" />

              <Flex dir="column" gap={4} ai="flex-start">
                <H6>{item.label}</H6>
                <BodyMain>{item.desc}</BodyMain>
              </Flex>

              <StyledLink href={item.href}>
                <SvgArrowRightSolid size={14} />
              </StyledLink>
            </AgentWrapper>
          )
        })}
      </Flex>

      <CancelButton type="gray-shadow" onClick={handleClose}>
        Cancel
      </CancelButton>
    </ModalStandardWrapper>
  )
}

const CancelButton = styled(Button)`
  display: none;
  @media (max-width: 768px) {
    height: 40px;
    width: 100%;
    margin-top: 24px;
    display: block;
  }
`

const StyledLink = styled(Link)`
  margin-left: auto;
  align-self: center;
`

const AgentWrapper = styled.div`
  border-radius: 16px;
  border: 1px solid ${colors.gray[100]};
  padding: 20px;
  min-width: 368px;
  display: flex;
  flex-direction: row;
  gap: 16px;
`

export default CallUsModal
